module.exports = "<!-- <h1>{{title}}</h1> -->\r\n<div #pieChartTarget>\r\n  <!-- <div class=\"col-md-12\">\r\n    <span class=\"tspan\">Latest Subscription Status</span>\r\n  </div> -->\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/pie-chart/pie-chart.component.html
// module id = ./src/app/modules/dashboard/pie-chart/pie-chart.component.html
// module chunks = main